// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_AtivoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/ativo/{owner}/{owner_id}
 *
 * Returns the single active payment link for the owner, or null if none.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_AtivoResponseDados = unknown[];

export type SubaccountsLinks_AtivoResponse = ApiResponse<SubaccountsLinks_AtivoResponseDados>;

registerResponseContract('SubaccountsLinks_AtivoResponse', {})
